module.exports = __webpack_public_path__ + "img/health-warning.66715399.svg";